// -------------------------------------
// SlickSlider
// -------------------------------------

(function($) {

  $(document).ready(function() {

    // Slick Slider
    $(".slick-slider").slick({
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: false,
      responsive: [{
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplaySpeed: 2500
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplaySpeed: 2000
          }
        }
      ]
    });

  });

})(jQuery);
